import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { SystemFile } from '../../../domain/common.model';
import { Policy, PolicyHeader } from '../../../domain/policy.model';
import { PolicyFilter } from '../../../domain/registry.domain';
import { GenericService } from './generic.service';
import { UtilsService } from './utils.service';

@Injectable()
export class PolicyService extends GenericService {
    constructor(private store: Store,
                private http: HttpClient) {
        super(store);
    }

    getOne(id: number) {
        return this.http.get<Policy>(`/api/secured/policy/${id}`);
    }

    getListByOfferId(id: number) {
        return this.http.get<Policy[]>(`/api/secured/policy/list/offer/${id}`);
    }

    getAll(request: PolicyFilter) {
        const params = UtilsService.buildQueryParams(request);
        return this.http.get<PolicyHeader[]>(`/api/secured/policy`, {params});
    }

    getAllCSV(filter: PolicyFilter) {
        const request = cloneDeep(filter);
        delete request.offset;
        delete request.limit;
        const params = UtilsService.buildQueryParams(request);
        return this.http.get<SystemFile>(`/api/secured/policy/export`, {params});
    }

    print(policyId: number, all: boolean) {
        return all
            ? this.http.get<SystemFile>(`/api/secured/policy/${policyId}/print/all`)
            : this.http.get<SystemFile>(`/api/secured/policy/${policyId}/print`);
    }

    printSummary(policyId: number) {
        return this.http.get<SystemFile>(`/api/secured/policy/${policyId}/print/summary`)
    }

    printFrontierCertificate(policyId: number) {
        return this.http.get<SystemFile>(`/api/secured/frontier/policy/${policyId}/print`);
    }
}
